import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { Link } from "react-router-dom";

// Fallback image
const fallbackImage = "https://t4.ftcdn.net/jpg/06/71/92/37/360_F_671923740_x0zOL3OIuUAnSF6sr7PuznCI5bQFKhI0.jpg";

const JobDetailsDescription = ({ jobDetails }) => {
    // Safely parse JSON fields
    const responsibilities = jobDetails?.Responsibilities?.split("|") || [];
    const qualifications = jobDetails?.Qualifications?.split("|") || [];
    const skillsExperience = jobDetails?.SkillsExperience?.split("|") || [];
    const skillTags = jobDetails?.SkillTags?.split("|") || [];

    return (
        <Card className="job-detail overflow-hidden">
            <div>
                <img
                    src={jobDetails?.CoverImage || fallbackImage}
                    alt="cover"
                    className="img-fluid"
                    draggable={false}
                    onError={(e) => (e.target.src = fallbackImage)}
                    style={{ width: '100%', maxHeight: '350px', objectFit: 'cover' }}
                />
                <div className="job-details-compnay-profile">
                    <img
                        src={jobDetails?.CompanyLogo || fallbackImage}
                        alt="logo"
                        className="img-fluid rounded-3"
                        draggable={false}
                        onError={(e) => (e.target.src = fallbackImage)}
                        style={{ maxWidth: '100px', maxHeight: '100px', objectFit: 'cover' }}
                    />
                </div>
            </div>

            <CardBody className="p-4">
                <div>
                    <Row>
                        <Col md={8}>
                            <h5 className="mb-1">{jobDetails?.JobTitle}</h5>
                            <ul className="list-inline text-muted mb-0">
                                <li className="list-inline-item">
                                    <i className="mdi mdi-account"></i>{" "}
                                    {jobDetails?.VacancyCount || 1} Vacancy
                                </li>
                                {jobDetails?.Rating && (
                                    <li className="list-inline-item text-warning review-rating">
                                        <span className="badge bg-warning">
                                            {jobDetails.Rating}
                                        </span>{" "}
                                        {[...Array(5)].map((_, i) => (
                                            <i
                                                key={i}
                                                className={`mdi mdi-star${i < Math.floor(jobDetails.Rating)
                                                    ? ""
                                                    : i < jobDetails.Rating
                                                        ? "-half-full"
                                                        : "-outline"
                                                    } align-middle`}
                                            ></i>
                                        ))}
                                    </li>
                                )}
                            </ul>
                        </Col>
                        <Col lg={4}>
                            <ul className="list-inline mb-0 text-lg-end mt-3 mt-lg-0">
                                <li className="list-inline-item">
                                    <div className="favorite-icon">
                                        <Link to="#">
                                            <i className="uil uil-heart-alt"></i>
                                        </Link>
                                    </div>
                                </li>
                                <li className="list-inline-item">
                                    <div className="favorite-icon">
                                        <Link to="#">
                                            <i className="uil uil-setting"></i>
                                        </Link>
                                    </div>
                                </li>
                            </ul>
                        </Col>
                    </Row>
                </div>

                <div className="mt-4">
                    <Row className="g-2">
                        <Col lg={4}>
                            <div className="border rounded-start p-3">
                                <p className="text-muted mb-0 fs-13">Experience</p>
                                <p className="fw-medium fs-15 mb-0">
                                    {jobDetails?.ExperienceRequired}
                                </p>
                            </div>
                        </Col>
                        <Col lg={4}>
                            <div className="border p-3">
                                <p className="text-muted fs-13 mb-0">Employee type</p>
                                <p className="fw-medium mb-0">{jobDetails?.EmployeeType}</p>
                            </div>
                        </Col>
                        <Col lg={4}>
                            <div className="border p-3">
                                <p className="text-muted fs-13 mb-0">Position Level</p>
                                <p className="fw-medium mb-0">{jobDetails?.PositionLevel}</p>
                            </div>
                        </Col>
                        <Col lg={4}>
                            <div className="border rounded-end p-3">
                                <p className="text-muted fs-13 mb-0">Offer Salary</p>
                                <p className="fw-medium mb-0">{jobDetails?.OfferSalary}</p>
                            </div>
                        </Col>
                    </Row>
                </div>

                <div className="mt-4">
                    <h5 className="mb-3">Job Description</h5>
                    <div className="job-detail-desc">
                        <p className="text-muted mb-0">{jobDetails?.JobDescription}</p>
                    </div>
                </div>

                {responsibilities.length > 0 && (
                    <div className="mt-4">
                        <h5 className="mb-3">Responsibilities</h5>
                        <ul className="job-detail-list list-unstyled mb-0 text-muted">
                            {responsibilities.map((item, idx) => (
                                <li key={idx}>
                                    <i className="uil uil-circle"></i> {item}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                {qualifications.length > 0 && (
                    <div className="mt-4">
                        <h5 className="mb-3">Qualification</h5>
                        <ul className="job-detail-list list-unstyled mb-0 text-muted">
                            {qualifications.map((item, idx) => (
                                <li key={idx}>
                                    <i className="uil uil-circle"></i> {item}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                {skillsExperience.length > 0 && (
                    <div className="mt-4">
                        <h5 className="mb-3">Skill & Experience</h5>
                        <ul className="job-detail-list list-unstyled mb-0 text-muted">
                            {skillsExperience.map((item, idx) => (
                                <li key={idx}>
                                    <i className="uil uil-circle"></i> {item}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}

                {skillTags.length > 0 && (
                    <div className="mt-4 d-flex flex-wrap align-items-start gap-1">
                        {skillTags.map((tag, idx) => (
                            <span key={idx} className="badge bg-primary">
                                {tag}
                            </span>
                        ))}
                    </div>
                )}

                <div className="mt-4 pt-3">
                    <ul className="list-inline mb-0">
                        <li className="list-inline-item mt-1">Share this job:</li>
                        <li className="list-inline-item mt-1">
                            <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`} target="_blank" className="btn btn-hover" style={{ backgroundColor: '#1877F2', color: '#fff' }}>
                                <i className="uil uil-facebook-f"></i> Facebook
                            </a>
                        </li>
                        <li className="list-inline-item mt-1">
                            <a to={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(window.location.href)}`} target="_blank" className="btn btn-hover" style={{ backgroundColor: '#0077B5', color: '#fff' }}>
                                <i className="uil uil-linkedin"></i>&nbsp; LinkedIn
                            </a>
                        </li>
                        {/* <li className="list-inline-item mt-1">
                            <Link to="#" className="btn btn-danger btn-hover">
                                <i className="uil uil-google"></i> Google+
                            </Link>
                        </li> */}
                    </ul>
                </div>
            </CardBody>
        </Card>
    );
};

export default JobDetailsDescription;
